import React from 'react';
import './ProductCatagories.css';
import { Link } from "react-router-dom";
import Domestic from './images.jpg'
const ProductCategories = () => {
  return (
    <div className="mainHome-container1">

        <div className="ALLOYMETALS-herosection" >
            <div className="ALLOYMETALS-herosection-pic">
                <div className="ALLOYMETALS-herosection-heading">
                    HOME / ALLOY METALS
                </div>
            
            </div>
            
        </div>
        <div className="Each-Product-container" >
        

            <div className="Each-Product-mid-left-container">
                <div className='Each-Product-tittle'>
                ALLOY METALS
                </div>
                <div className='Each-Product-mid-details'>
                Alloy metals are materials made by combining two or more metallic elements or a metal with non-metal elements to enhance their properties. The purpose of alloying is to improve strength, durability, corrosion resistance, heat resistance, and other mechanical properties. Common examples include steel (iron + carbon), brass (copper + zinc), bronze (copper + tin), and aluminum alloys. </div>
                    
            </div>
            <div className="Each-Product-mid-right-container">
                <div className="tranding-pics">
                    <img src={Domestic} alt="" className='tranding-left-pics' />
                </div>

            </div>
        </div>
    <section className="Each-Product-Details-card" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>Benifits</h2>
      
      <section className="product-categories-list">
      <div className="product-categories-list-header">
        
      </div>

      <div className="product-categories-list-grid">
        {productCategoryDetails.map((productCategory, index) => (
          <div key={index} className="product-categories-list-box">
            <div className="Each-product-benifitt-icon"><img src={productCategory.image} alt={productCategory.image} className='Each-Product-Details-card-img'/></div>
            <h3>{productCategory.title}</h3>
            <p>{productCategory.description}</p>
          </div>
        ))}
      </div>
    </section>
      {/* <button className="view-button">View All Products</button> */}
      {/* <h2 className='Product-category-title'>Browse by Category</h2> */}
    </section>
    
    </div>
  );
};

export default ProductCategories;

const productCategoryDetails = [
    {
      title: "Increased Strength & Durability",
      description: "Alloy metals offer increased strength and durability, making them more resistant to wear, tear, and mechanical stress than pure metals. This enhances their performance in construction, automotive, aerospace, and industrial applications.",
      image: "/Products/Alloy/1.jpg"
    },
    {
      title: "Corrosion Resistance",
      description: "Stainless steel, aluminum, and other alloys resist rust and environmental damage, ensuring longevity and reliability in construction, automotive, and marine applications while reducing maintenance costs and enhancing durability in harsh conditions.",
      image: "/Products/Alloy/2.jpg"
    },
    {
      title: "Cost Efficiency",
      description: "Alloys are cost-effective and practical alternatives to rare or expensive pure metals, offering enhanced strength, durability, and performance while reducing material costs in industries like construction, automotive, and manufacturing.",
      image: "/Products/Alloy/3.jpg"
    },
    {
      title: "Enhanced Electrical & Thermal Conductivity",
      description: "Copper and aluminum alloys, known for their superior conductivity, are widely used in electrical wiring and heat exchangers, ensuring efficient energy transfer, reduced power loss, and enhanced performance in electrical and thermal applications.",
      image: "/Products/Alloy/4.jpg"
    },
    
  ];
  